module.exports = __webpack_public_path__ + "img/mind_template_item_4_2.1699929c.png";